import {
  Checkbox,
  checkboxStates,
  TickIcon,
} from "@visiblethread/react-components";
import { bool, shape, string } from "prop-types";

const CheckboxAction = ({ item, isApplied, isChecked }) => {
  if (isApplied) {
    return (
      <TickIcon
        className="file_explorer__list__item__actions__ticked"
        height={8}
        width={13}
      />
    );
  }

  return (
    <Checkbox
      state={isChecked ? checkboxStates.checked : checkboxStates.empty}
      aria-label={`Select ${item.name}`}
      data-testid={`checkbox-${item.name}`}
      handleChange={() => {}}
      readOnly
    />
  );
};

CheckboxAction.propTypes = {
  item: shape({
    name: string.isRequired,
  }).isRequired,
  isApplied: bool.isRequired,
  isChecked: bool.isRequired,
};

export default CheckboxAction;
